import Icon from "@/components/Icon/Icon";
import { LabelXBase } from "@/components/LabelX";
import { HStack, VStack } from "@/components/Layout";
import { Text } from "@/components/Typography";
import { cn } from "@/lib/cn";
import type { ComponentProps } from "react";
import { match } from "ts-pattern";
import { AvatarApp } from "../Avatar/AvatarApp";

type Props = {
  name: string;
  /**
   * アバター画像のURL（デバイスの画像が設定されていないことを考慮して、undefinedを許容する）
   */
  avatarUrl?: string;
  /**
   * 表示するテナント名（表示しない場合は指定しない）
   */
  tenantName?: string;
  /**
   * ホバーしたら大きくなってほしいかどうか
   */
  hoverScale?: boolean;
} & Omit<ComponentProps<typeof LabelXBase>, "label">;

/**
 * アプリのアバターとラベルを表示するコンポーネント
 */
export function LabelApp({ avatarUrl, hoverScale, ...props }: Props) {
  const size = match(props.size)
    .with("Default", () => 24 as const)
    .with("Large", () => 32 as const)
    .with("Small", () => 16 as const)
    .with("ExtraSmall", () => 12 as const)
    .otherwise(() => 24 as const);

  return (
    <LabelXBase {...props} label={Label(props)}>
      <AvatarApp
        src={avatarUrl}
        name={props.name}
        size={size}
        // hoverScaleが指定されているか、previewCardがある場合にhoverScaleをtrueにする
        hoverScale={hoverScale ?? !!props.previewCardContent}
        className={cn("shrink-0")}
      />
    </LabelXBase>
  );
}

function Label({ name, tenantName }: { name: string; tenantName?: string }) {
  if (!tenantName) {
    return name;
  }

  return (
    <VStack>
      <Text variant={"label"} className="text-neutral-on-fill">
        {name}
      </Text>
      <HStack className="gap-1 text-neutral-muted-on-fill">
        <Icon iconName="NetworkIcon" size={12} />
        <Text variant={"labelSmall"} className="text-neutral-muted-on-fill">
          {tenantName}
        </Text>
      </HStack>
    </VStack>
  );
}
